import { APP_EVENTS } from "@Core";
import { PAGE_SUITE_PAGE_TYPES, PageSuiteContentViewEvent } from "@Modules/index";
import { Logger, LoggerService } from "@Shared/logger";
import { EventUtil } from "@Shared/utils";
import { LazyValue } from "@Shared/utils/data";

//NOTE: We use a repository so we can store data from pageview or articleview events. Besides checking if this is the front page or an article for Connext we don't really do anything else with all the data right now. But if we ever need to track or reference this in the future we'll have it. 

/**
 * Repository base class for PageSuite.
 */
export abstract class PageSuiteRepository {
    private LoggerBase: Logger = LoggerService.createLogger("PageSuiteRepository");

    protected isArticle: boolean = false;
    get IsArticle(): boolean {
        if (this.isArticle) {
            return false;
        }
        return this.isArticle;
    }
    //use protected so derived classes can modify, but not outside pagesuite service class.
    protected isFront: boolean = false;
    get IsFront(): boolean {
        if (this.isArticle) {
            return false;
        }
        return this.isFront;
    }

    constructor() {
        this.LoggerBase.trace("****  CTOR ****");

    }

    protected handleContentChange(event: PageSuiteContentViewEvent): void {
        this.LoggerBase.trace("handleContentChange", event);
        EventUtil.fireEvent(APP_EVENTS.onPagesuiteContentChanged, event);
        this.determineIfFront(event);
        //call psRegister if it exists on all content change (pageview and articleview)
        window['psRegister']?.();
    }

    private determineIfFront(event: PageSuiteContentViewEvent): void {
        this.LoggerBase.trace("determineIfFront", event);
        const pageLength = event.pageNumber.length;
        const firstPageNumber = event.pageNumber[0];
        const firstPageType = event.pageTypes[0];
        this.LoggerBase.trace("determineIfFront", "firstPageNumber ", firstPageNumber, " firstPageType ", firstPageType, " pageLength ", pageLength);
        if ((firstPageNumber === 1 || firstPageNumber === 2) || (firstPageType === PAGE_SUITE_PAGE_TYPES.advertisement && firstPageNumber === 1)) {
            this.isFront = true;
        } else {
            this.isFront = false;
        }
        this.LoggerBase.trace("determineIfFront", "isFront set to ", this.isFront);

        if (pageLength === 1) {
            //single/mobile view.

        } else {
            //we have 2 pages,
        }

        window['Connext']?.Run();

    };
}